import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/Terms&PrivacySocialApi/Terms&PrivacySocial";
import { validateForm } from "utils/validation";
import { TermsAndPrivacyRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import TermsAndPrivacyEditForm from "./Componates/TermsAndPrivacyEditForm";
import fields from "../json/TermsAndPrivacyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditTermAndPrivacy = () => {
  const navigate = useNavigate();
  const { formdataterms } = fields;
  const { id } = useParams();

  // Initialize form data
  const initialValues = formdataterms.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const {
    values,
    errors,
    handleChange,
    setErrors,
    setValues,
  } = useFormChange(initialValues, TermsAndPrivacyRules);

  // Fetch data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdataterms,
    GetById,
    setValues
  );

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Update({id,data:formValues});
    },
    (vals) => {
      const err = validateForm(vals, TermsAndPrivacyRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Terms & Privacy updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <TermsAndPrivacyEditForm
        fields={formdataterms}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Terms & Privacy"
      />
    </>
  );
};

export default EditTermAndPrivacy;
